const valueFormat = (stringValue) => {
    // Converts the variable to a number
    const withoutPercentage = stringValue[stringValue.length - 1] === "%" ? stringValue.slice(0, -1) : stringValue;
    const withDecimalPoint = withoutPercentage.replace(/,/g, ".");
    const numberValue = Number(withDecimalPoint);

    // Returns the value according to your type
    if (isNaN(numberValue)) return stringValue;
    else return String(Number(numberValue.toFixed(2))).replace(".", ",");
}

export default valueFormat;